<template>
  <div
    class="situation-wrap"
    v-loading="isLoading"
    element-loading-text="拼命加载中…"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 1)"
  >
    <!-- 导出图片确认 -->
    <CheckExportData
      :type-list="categories"
      v-if="checkExportVisible"
      v-loading="loadingDownloadExport"
      element-loading-text="拼命加载中…"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"
      @handleExport="handleExport"
      @cancelExportImgs="checkExportVisible = false"
    ></CheckExportData>
    <!-- 电磁空间 -->
    <TopElectricChart
      ref="电磁空间"
      v-if="curSystemType === '电磁空间'"
      :categoryData="ChartDataContariner.categoryData"
      :tableData="tableData"
      :subcategoryNameList="ChartDataContariner.subcategoryNameList"
      :checkedSubcategoryNameList="ChartDataContariner.checkedSubcategoryNameList"
      @change="changeisShowChart2"
    >
      <CommonContainer
        :options="mapContainer.mapName[mapType]"
        class="map-wrap"
        @handleSelect="checkCountry"
        :title="mapContainer.mapTitle"
        :is-map="true"
      >
        <Map
          :mapType="mapType"
          @check="checkCountry"
          :selectedMode="mapContainer.selectedMode"
          :region-value="regionValue"
        >
          <template>
            <el-button type="primary" class="export-button" @click="checkExportVisible = true"
            v-show="downloadFloat"
              >下载报告</el-button
            >
          </template>
        </Map>
      </CommonContainer>
    </TopElectricChart>

    <!-- 海洋信息 -->
    <TopSeaChart
      ref="海洋信息"
      v-if="curSystemType === '海洋信息'"
      :categoryData="ChartDataContariner.categoryData"
      :tableData="tableData"
      :subcategoryNameList="ChartDataContariner.subcategoryNameList"
      :checkedSubcategoryNameList="ChartDataContariner.checkedSubcategoryNameList"
      @change="changeisShowChart"
      :newRecords="$store.state.cardInformationList"
    >
    <div style="display:flex;flex-wrap: wrap;width: 52vw">
      <CommonContainer
        class="map-wrap"
        :options="mapContainer.mapName[mapType]"
        @handleSelect="checkCountry"
        :title="mapContainer.mapTitle"
        :is-map="true"
      >
        <!-- <Map :mapType="mapType" @check="mapCheck" /> -->
        <Map
          mapId="situationMap"
          mapType="all"
          @check="mapCheck"
          :selectedMode="mapContainer.selectedMode"
          :region-value="regionValue"
        >
          <template>
            <el-button type="primary" class="export-button"
            @click="checkExportVisible = true" 
            v-show="downloadFloat"
              >下载报告</el-button
            >
          </template>
        </Map>
      </CommonContainer>
      <CommonContainer
        class="regional-analysis"
        :scale="styleContainer.footerChartStyle"
        :title="$store.state.lineTitle"
        :type-list="ChartDataContariner.subcategoryNameList.产品"
        @handleTypesSelect="handleTypesSelected"
        @change="changeisShowChart4"
      >
        <!-- <template slot-scope="scope">
          <BarChart
            ref="产品"
            :mode="'v'"
            :bar-data="ChartDataContariner.categoryData.产品"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></BarChart>
          <DetailTable
            :type-list="ChartDataContariner.checkedSubcategoryNameList.产品"
            :table-data="tableData.产品"
            v-else
          ></DetailTable>
        </template> -->
        <LieCharts :echartsList="$store.state.echartsList"></LieCharts>
      </CommonContainer>
      </div>
    </TopSeaChart>

  
  </div>
</template>

<script>
// import * as echarts from "echarts"
import Map from "@/components/Map"
import CommonContainer from "@/components/CommonContainer"
// import BarChart from "@/components/Charts/BarChart"
// import LineChart from "@/components/Charts/LineChart"
import TopElectricChart from "./topElectricChart.vue"
import TopSeaChart from "./topSeaChart.vue"
// import DetailTable from "@/components/Tables/DetailTable"
import { service, request } from "@/utils/request"
import { initData, updateRegionValue } from "@/views/News/index"

import CheckExportData from "../CheckExportData/index.vue"
import topCategories from "@/modules/topCategories"
import LieCharts from "@/components/EchartsAnalysis/lineEcharts"  // 地域资源分析
// import func from 'vue-editor-bridge'
import api from "@/services/api"
// import { getRegionInformation } from "@/utils/loadData"

export default {
  props: {
    mapType: {
      type: String,
      require: true,
    },
  },
  components: {
    Map,
    TopElectricChart,
    CommonContainer,
    // BarChart,
    LieCharts, // 地域资源分析
    TopSeaChart,
    // DetailTable,
    CheckExportData,
   
  },
  data() {
    return {
      downloadFloat:true,
      isLoading: true,
      curSystemType: this.$store.state.systemType,
      regionValue: "",
      loadingDownloadExport: false,
      //是否显示下载报告弹框
      checkExportVisible: false,
      tableData: {
        政策法规: [],
        理论: [],
        行业应用: [],
        人才培养: [],
        技术: [],
        产品: [],
      },
      newRecords:[],
      echartsList:[],
      ChartDataContariner: {
        allSystemInformation: null,
        checkDataList: null,
        categoryData: {}, // 存放各分类的数据
        categoryDataCache: {}, // 缓存数据，用于子分类过滤
        subcategoryNameList: {}, // 大类下的子分类名称数组
      },
      mapContainer: {
        mapName: null, // 国家名称列表对象,global,domestic
        mapTitle: "地图",
        selectedRegion: [],
        selectedMode: "single",
      },
      styleContainer: {
        topChartStyle: { width: "22vw", height: "29vh" },
        topElectricChartStyle: { width: "22vw", height: "50vh" },
        footerChartStyle: { width: "47vw", height: "29vh" },
        chartScale: { width: "100%", height: "100%" },
      },
      //详细对比页面所有一级分类
      categories: null,
      isShowChart:true,
      isShowChart2:true,
      isShowChart3:true,
      isShowChart4:true,
      isShowChart5:true,
      isShowChart6:true,
      ojectList:{ // 折线图的标题字
        1: "新闻资讯",
        2: "热搜事件",
        3: "社交评论",
      },
      // 台湾的死数据
      taiwanBarList:{
          "key": [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          "value": [
            {
              "1": 119,
              "2": 107,
              "3": 98
            },
           {
              "1": 200,
              "2": 30,
              "3": 67
            },
            {
              "1": 88,
              "2": 55,
              "3": 97
            },
            {
              "1": 284,
              "2": 73,
              "3": 150
            },
           {
              "1": 269,
              "2": 63,
              "3": 200
            },
            {
              "1": 300,
              "2": 99,
              "3": 88
            },
            {
              "1": 243,
              "2": 230,
              "3": 150
            },
           {
              "1": 296,
              "2": 230,
              "3": 267
            },
            {
              "1": 188,
              "2": 155,
              "3": 197
            },
             {
              "1": 368,
              "2": 237,
              "3": 40
            },
             {
              "1": 186,
              "2": 95,
              "3": 100
            },
             {
              "1": 37,
              "2": 75,
              "3": 269
            },
          ],
          "chart": [
            "line",
            "bar"
          ]
        },
      taiwanPieList:{
          "key": [
            "两岸关系",
            "九二共识",
            "惠台政策",
            "反对台独",
            "一个中国原则"
          ],
          "value": [
            200,
            136,
            369,
            1000,
            2000
          ],
          "chart": [
            "pie"
          ]
      }
    }
  },
  computed: {
    watchSystemType() {
      return this.$store.getters.getSystemType
    },
  },
  watch: {
    watchSystemType: async function (newSystemType) {
      //更新一级分类列表
      this.updateTopCategories(newSystemType)
      // this.regionValue = await updateRegionValue(this, newSystemType)
      await updateRegionValue(this, newSystemType)
      this.curSystemType = newSystemType
      if (this.$store.state.curRegion !== "中国") {
        this.initCountry(this.$store.state.curRegion)
      } else {
        this.initCountry()
      }
    },
    // "this.$store.systemType": {
    //   handler(newVal) {
    //     this.categories =
    //       newVal === "电磁空间" ? topCategories.electricCategory : topCategories.seaCategory
    //     console.log(newVal, this.categories)
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  methods: {
    
      /**
     * 点击地图事件
     */
    mapCheck(regionName) {
      console.log('地区',regionName);
      this.isSearch = false;
      this.currentPage = 1;
      this.mapName = regionName;
      this.getRegionInformation();
      this.$store.commit('setbarTitle',"时间统计分析")
      this.$store.commit('setlineTitle',"地域资讯分析")
      this.$store.commit('setpieTitle',"热搜事件分析")
      this.$store.commit('setlegendList',this.ojectList)
      console.log('setlegendList',this.$store.state.echartslegendList);
    },
    /**
     * 点击地图接口
     */
    getRegionInformation() {
      let domainId = 1;
      if (this.$store.getters.getSystemType == "海洋信息") {
        domainId = 1;
      } else {
        domainId = 2;
      }
      let regionMapId = this.$store.getters.getRegionMap[this.mapName];
      let is_domestic = false;
      if (regionMapId >= 192) {
        is_domestic = true;
      }
      request.region_information
        .find("", {
          domain_id: domainId,
          is_domestic: is_domestic,
          region_id: this.$store.getters.getRegionMap[this.mapName] || 140,
          category_code: "1.",
          page_size: this.pageSize,
          page_to: this.currentPage,
        })
        .then((res) => {
          this.testData = [];
          const records = res.data.data.records;
          this.newRecords = records
          if(records.length<1){
            this.$message.info("暂无该信息!")
          }
          this.$store.commit('setcardInformationList',res.data.data)
          // console.log(this.$store.state.cardInformationList);
          records.forEach((b) => {
            this.testData.push({
              cardTitle: b.information.title,
              cardContent: b.information.short_content,
              href: b.information.link,
              the_time: b.information.the_time,
              id:b.information.id
            });
          });
          this.total = res.data.data.total_records;
        });
        // const params = { 
        //     domain_id: domainId,
        //     is_domestic: false,
        //     statistic_kind: "region"
        // }
        // api.region_information.summarize(params).response.then((res)=>res.data).then((res) =>{
        //   if(res.code == 200) {
        //     const e = this.$store.getters.getRegionMap[this.mapName]
        //     this.$store.commit('setechartsList',res.data.filter(
        //       (item) => item.region_id === e
        //     )[0])
        //     // console.log(this.$store.state.echartsList,'地域');
        //   }
        // })
         const param = { 
            'domain_id': domainId,
            "region_id": this.$store.getters.getRegionMap[this.mapName],
            "info_category_id": 1,
            "statistic_kind": 2,
            "event_id": 0,
            "if_total": false,
        }
         api.region_information.summarize(param,{params:{name:"时间统计分析"}}).response.then((res)=>res.data).then((res) =>{
          if(res.code == 200) {
            if(this.$store.getters.getRegionMap[this.mapName] === 223){
              this.$store.commit('setbarchartsList',this.taiwanBarList)
            }else{
              this.$store.commit('setbarchartsList',res.data)
            }
            // console.log(this.$store.state.barchartsList,'时间统计')
          }
        })
         const param1 = { 
            'domain_id': domainId,
            "info_category_id": 1,
            "statistic_kind": 3,
            "region_id": this.$store.getters.getRegionMap[this.mapName],
            "event_id": 0,
            "if_total": false
        }
         api.region_information.summarize(param1,{params:{name:"热搜事件分析"}}).response.then((res)=>res.data).then((res) =>{
          if(res.code == 200) {
            if(this.$store.getters.getRegionMap[this.mapName] === 223){
              this.$store.commit('setpiechartsList',this.taiwanPieList)
            }else{
              this.$store.commit('setpiechartsList',res.data)
            }
            // console.log(this.$store.state.piechartsList,'情绪');
          }
        })
    },
    changeisShowChart(val){
        this.isShowChart = val
       this.downloadFloat = this.isShowChart && this.isShowChart2 && this.isShowChart3&& this.isShowChart4&& this.isShowChart5&& this.isShowChart6
    },
    changeisShowChart2(val){
        this.isShowChart3 = val
       this.downloadFloat = this.isShowChart && this.isShowChart2 && this.isShowChart3&& this.isShowChart4&& this.isShowChart5&& this.isShowChart6
    },
    changeisShowChart3(val){
        this.isShowChart4 = val
       this.downloadFloat = this.isShowChart && this.isShowChart2 && this.isShowChart3&& this.isShowChart4&& this.isShowChart5&& this.isShowChart6
    },
    changeisShowChart4(val){
        this.isShowChart5 = val
       this.downloadFloat = this.isShowChart && this.isShowChart2 && this.isShowChart3&& this.isShowChart4&& this.isShowChart5&& this.isShowChart6
    },

    /**
     * 处理table的数据， 结果需要有国家的分类数据
     * @param {*} arr 国家下的所有数据
     */
    getTableData(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (!this.tableData[arr[i].categoryName]) continue // 没有该领域，跳过

        this.tableData[arr[i].categoryName].push(arr[i])
      }
      this.isLoading = false
    },

    todocheckCountry(_this, data) {
      // data先以年份做键值匹配，等排序完再传入数组
      const otherList = [] // 不存在二级标题的先存下
      // _this.ChartDataContariner.checkDataList
      _this.ChartDataContariner.categoryData = {}
      data.map((v) => {
        // 不存在二级标题的，先过滤，后面要做保存，如果全都不存在，则只展示一级
        if (v.categorySubName) {
          // y轴时间，取年份, map结束需要排序
          const curYear = v.datetime.split("-")[0]
          // 分类初始化
          if (!_this.ChartDataContariner.categoryData[v.categoryName]) {
            _this.ChartDataContariner.categoryData[v.categoryName] = [
              {
                name: v.categorySubName,
                unit: v.unit,
                data: {},
              },
            ]
          }
          // 是否已经存在categorySubName分类
          let flag = false,
            len = _this.ChartDataContariner.categoryData[v.categoryName].length
          for (let i = 0; i < len; i++) {
            if (
              _this.ChartDataContariner.categoryData[v.categoryName][i].name === v.categorySubName
            ) {
              let num = _this.ChartDataContariner.categoryData[v.categoryName][i].data[curYear]
              _this.ChartDataContariner.categoryData[v.categoryName][i].data[curYear] = num
                ? num + v.quantity
                : v.quantity
              flag = true
              break
            }
          }
          if (!flag) {
            // 还未存在categorySubName分类
            _this.ChartDataContariner.categoryData[v.categoryName].push({
              name: v.categorySubName,
              unit: v.unit,
              data: { [curYear]: v.quantity },
            })
          }
        } else {
          otherList.push(JSON.parse(JSON.stringify(v)))
        }
      })
      const otherCategoryName = []
      for (let i = 0; i < otherList.length; i++) {
        const curYear = otherList[i].datetime.split("-")[0]
        if (otherCategoryName.includes(otherList[i].categoryName)) {
          let num =
            _this.ChartDataContariner.categoryData[otherList[i].categoryName][0].data[curYear]

          _this.ChartDataContariner.categoryData[otherList[i].categoryName][0].data[curYear] = num
            ? num + otherList[i].quantity
            : otherList[i].quantity
          continue
        }

        if (!_this.ChartDataContariner.categoryData[otherList[i].categoryName]) {
          _this.ChartDataContariner.categoryData[otherList[i].categoryName] = [
            {
              //如果没有二级分类则用一级分类代替
              name: otherList[i].categorySubName || otherList[i].category,
              unit: otherList[i].unit,
              data: { [curYear]: otherList[i].quantity },
            },
          ]
          otherCategoryName.push(otherList[i].categoryName)
        }
      }

      // 缓存子分类
      _this.ChartDataContariner.categoryDataCache = JSON.parse(
        JSON.stringify(_this.ChartDataContariner.categoryData)
      )

      // 处理子分类列表
      _this.doSubCategList(_this.ChartDataContariner.categoryData)

      // 处理table的数据
      _this.getTableData(data)
    },

    /**
     * 处理子分类列表
     */
    doSubCategList(categObj) {
      for (const key in categObj) {
        this.ChartDataContariner.subcategoryNameList[key] = []
        for (const subName in categObj[key]) {
          this.ChartDataContariner.subcategoryNameList[key].push(categObj[key][subName].name)
        }
      }
      //深拷贝一份子分类数据用于列表的子分类
      this.ChartDataContariner.checkedSubcategoryNameList = JSON.parse(
        JSON.stringify(this.ChartDataContariner.subcategoryNameList)
      )
      // console.log(this.ChartDataContariner.subcategoryNameList, 123456)
    },

    /**
     * doCheckCountry
     *
     */
    async doCheckCountry(data, processedData) {
      const _this = this
      //   if(this.mapContainer.selectedRegion.length === 2){  // 多选只能选两个
      //     // this.mapContainer.selectedRegion.unshift()
      //     this.mapContainer.selectedMode = 'false'
      //     return
      //   }
      //   this.mapContainer.selectedRegion.push(data)
      _this.mapContainer.mapTitle = data

      // setTimeout(() => {
      // const regionInformation = await getRegionInformation(_this, data, false, _this.regionMap)
      // _this.ChartDataContariner.checkDataList =
      //   // regionInformation[_this.$store.getters.getSystemType][data]
      //   _this.$store.getters.getRegionInformation[_this.$store.getters.getSystemType][data]
      // console.log(processedData, "选择地区下的所有数据")

      _this.todocheckCountry(_this, processedData[_this.$store.getters.getSystemType][data])

      // console.log(_this.ChartDataContariner.categoryData, "dfghjkjjjjj")
      // }, 100)
    },

    /**
     * 处理图表上子分类
     */
    handleTypesSelected(subCategObj) {
      debugger
      this.ChartDataContariner.checkedSubcategoryNameList[subCategObj.name].length = 0
      subCategObj.checkedTypes.map((value) => {
        this.ChartDataContariner.checkedSubcategoryNameList[subCategObj.name].push(value)
      })
      // console.log("分类名称：（产品）", subCategObj.name, "选中List：", subCategObj.checkedTypes)
      // console.log(this.ChartDataContariner.categoryData[subCategObj.name], "当前分类下的数据")
      this.filterCategoryData(subCategObj.name, subCategObj.checkedTypes)

      // console.log(this.ChartDataContariner.categoryData[subCategObj.name], "当前分类下的数据")
    },

    /**
     * 点击子分类过滤分类图表数据
     * @param key 分类名称
     * @param arr 选中子分类数组
     */
    filterCategoryData(key, arr) {
      let newCategoryData = []
      this.ChartDataContariner.categoryDataCache[key].forEach(function (item) {
        if (arr.includes(item.name)) {
          newCategoryData.push(item)
        }
      })
      this.ChartDataContariner.categoryData[key] = newCategoryData
    },

    /**
     * 地图区域点击事件
     * @param data 区域名称
     */
    async checkCountry(data) {
      const _this = this
      _this.isLoading = true
      _this.$store.commit("setCurRegion", data)
      let processedData
      if (_this.mapType === "global" && data !== "中国") { 
        processedData = await initData(this, data, false)
      } else if (data === "中国") {
        processedData = this.$store.getters.getChinaValue
      } else {
        processedData = await initData(this, data, true)
      }
      if (
        (_this.$store.getters.getSystemType == "海洋信息" &&
          !Object.keys(processedData.海洋信息).length) ||
        (_this.$store.getters.getSystemType == "电磁空间" &&
          !Object.keys(processedData.电磁空间).length)
      ) {
        this.$message.warning("请选择有情报的地区")
        return
      }

      _this.ChartDataContariner.categoryData = {} // 清空
      _this.tableData = {
        // 清空
        政策法规: [],
        理论: [],
        行业应用: [],
        人才培养: [],
        技术: [],
        产品: [],
      }
      _this.ChartDataContariner.subcategoryNameList = {
        政策法规: [],
        理论: [],
        行业应用: [],
        人才培养: [],
        技术: [],
        产品: [],
      }

      this.doCheckCountry(data, processedData)
    },

    /**
     * 获取后端数据
     */
    getServiceData() {
      return service.api
    },

    // 初始化城市选择
    initCountry(data) {
      if (arguments.length) {
        // 如果传了值 则触发这个值
        this.checkCountry(data)
        return
      }

      if (this.mapType === "domestic") {
        this.checkCountry("北京")
      } else if (this.mapType === "global") {
        this.checkCountry("中国")
      }
    },
    /**
     * @param {Array} itemList 选中的一级分类列表
     * @returns 无返回值
     */
    handleExport(itemList) {
      window.open("/基地列表.docx")
      // const items = []
      // itemList.forEach((category) => {
      //   if (!topCategories.commonCategory.includes(category)) {
      //     if (this.$store.getters.getSystemType === "海洋信息") {
      //       const item = this.$refs["海洋信息"].$refs[category].handleSaveImage()
      //       item.category_name = category
      //       items.push(item)
      //     } else {
      //       const item = this.$refs["电磁空间"].$refs[category].handleSaveImage()
      //       item.category_name = category
      //       items.push(item)
      //     }
      //   } else {
      //     const item = this.$refs[category].handleSaveImage()
      //     item.category_name = category
      //     items.push(item)
      //   }
      // })
      // request.reportGenerate
      //   .create({
      //     country_name: this.$store.getters.getCurRegion,
      //     domain_name: this.$store.getters.getSystemType,
      //     items,
      //   })
      //   .then((res) => {
      //     const { code, data } = res.data
      //     if (code === 200) {
      //       const { file_url } = data
      //       window.open(file_url, "_blank")
      //       this.$message.success("报告已生成，下载中...")
      //     } else {
      //       this.$message.error("生成报告失败!")
      //     }
      //     this.checkExportVisible = false
      //   })
    },
    /**
     *@param {String} systemType 领域类型
     */
    updateTopCategories(systemType) {
      this.categories =
        systemType === "电磁空间"
          ? [...topCategories.electricCategory, ...topCategories.commonCategory]
          : [...topCategories.seaCategory, ...topCategories.commonCategory]
    },
  },
  created() {
    //更新一级分类列表
    this.updateTopCategories(this.watchSystemType)
    // 初始默认选择
    this.initCountry()

    // 初始化国家列表，传入map的搜索框
    this.mapContainer.mapName = this.$store.getters.getRegionNameList
  },
  mounted() {
    // this.categories =
    //   this.$store.getters.getSystemType === "电磁空间"
    //     ? topCategories.electricCategory
    //     : topCategories.seaCategory
    // console.log(isShowChart,"isShowChart");
  },
}
</script>

<style lang="scss" scoped>
$mainHeight: 60vh; // 上部的容器、图表、地图的高度
$footerHeight: calc(40vh - 10vh); // 30vh 底部的容器、图表
$fontColor: #ccc; //字体颜色
.regional-analysis{
  width:50vw!important;
}
.situation-wrap {
  height: calc(100vh - 61px);
  margin: 0 20px;
  // border: 1px solid;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  .main-wrap {
    width: 100%;
    height: $mainHeight;
    // border: 1px solid;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .map-wrap {
      width: 50vw;
      height: $mainHeight;

      .export-button {
        background-color: transparent;
        border: 1px solid rgb(43, 57, 87, 0.4);
        padding: 2vh 1vw;
        color: $fontColor;
        &:hover {
          background-color: #293e79;
        }
      }
    }

    .topChart-wrap {
      width: calc((100% - 50vw - 2vw) / 2); // 24vw
      height: $mainHeight;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
    // .topChart-wrap > div:not(.angle){   // 未生效，需要加在content-area上
    //   height: 60vh;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: space-around;
    //   align-items: center;
    // }
  }

  .footer-wrap {
    width: 100%;
    height: $footerHeight;
    // border: 1px solid;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //上部和底部两边对齐
    padding: 0 15px;

    .footerChart-wrap {
      width: 48vw;
      height: $footerHeight;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
